export enum Format {
  TwelveHours = 'h:mmA',
  WeekDay = 'dddd',
}

export enum Unit {
  Day = 'day',
  Minutes = 'minutes',
}
